import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import {useState, useId} from 'react'

export interface ShutdownDetailCollapsibleProps {
  title: React.ReactNode
  defaultOpen?: boolean
  rightSlot?: React.ReactNode
  children: React.ReactNode
  className?: string
  contentClassName?: string
  'data-cy'?: string
}

export const ShutdownDetailCollapsible: React.FC<ShutdownDetailCollapsibleProps> = ({
  title,
  defaultOpen = true,
  rightSlot,
  children,
  className,
  contentClassName,
  'data-cy': dataCy
}) => {
  const [open, setOpen] = useState(defaultOpen)
  const contentId = useId()

  return (
    <div className={className} data-cy={dataCy}>
      <div className="flex items-center justify-between mb-8">
        <div className="flex flex-row gap-2 items-center">
          <IconButton
            size="small"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls={contentId}
            sx={{
              transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
              transition: (theme) =>
                theme.transitions.create('transform', {
                  duration: theme.transitions.duration.shortest
                })
            }}
          >
            <ExpandMoreIcon fontSize="small" />
          </IconButton>
          <div className="font-medium">{title}</div>
        </div>

        <div className="flex items-center gap-2">{rightSlot}</div>
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <div id={contentId} className={contentClassName}>
          {children}
        </div>
      </Collapse>
    </div>
  )
}
